export default __webpack_public_path__ + "static/media/about_first.134451fe.svg";